import * as React from "react";
import { resolveDiagramSvgHeight } from "../shared/diagramSvgDimensions";


import { MethylationDetoxificationPhase2DiagramContent } from "./MethylationDetoxificationPhase2Diagram";
import { MethylationDetoxificationPhase2KeyContent } from "./MethylationDetoxificationPhase2Key";

const SvgMethylationDetoxificationPhase2DiagramKey = ({
  geneColors = {},
  expectedSnps = {},
  showKey = true,
  keyControlsId = "diagram-key",
  onGeneClick,
  width: widthProp,
  height: heightProp,
  ...props
}) => {
  const diagramOnly = !showKey;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      width={widthProp ?? 1024}
      height={resolveDiagramSvgHeight(heightProp, diagramOnly, 934, 1184)}
      viewBox={diagramOnly ? "0 176 1024 934" : "0 0 1024 1184"}
    >
      <g id="methylation-detoxification-phase2-diagram+key" clipPath="url(#clip0_18382_42717)">
        <rect width={1024} height={diagramOnly ? 934 : 1184} fill="white" />
        {showKey && (
          <g id={keyControlsId}>
            <MethylationDetoxificationPhase2KeyContent />
          </g>
        )}
        <g transform={showKey ? `translate(0 74)` : undefined}>
          <MethylationDetoxificationPhase2DiagramContent
            geneColors={geneColors}
            expectedSnps={expectedSnps}
            onGeneClick={onGeneClick}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18382_42717">
          <rect width={1024} height={1184} fill="white" />
        </clipPath>
        <clipPath id="clip1_18382_42717">
          <rect width={1024} height={934} fill="white" transform="translate(0 176)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgMethylationDetoxificationPhase2DiagramKey;
